import { Modal, Button, Badge } from './ui';
import { FileSpreadsheet, Users, Smartphone, ShieldCheck } from 'lucide-react';
import type { ReactNode } from 'react';

const ITEMS: { icon: ReactNode; text: string }[] = [
  { icon: <FileSpreadsheet size={15} />, text: 'Mitglieder aus Excel importieren: ausgefüllte Vorlage hochladen, Vorschau prüfen, fertig.' },
  { icon: <Users size={15} />, text: 'Doppelte werden automatisch erkannt — wer in zwei Sektionen ist, bleibt ein Mitglied.' },
  { icon: <Smartphone size={15} />, text: 'Modernere Navigation am Handy und aufgeräumte Einstellungen.' },
  { icon: <ShieldCheck size={15} />, text: 'Fehlerhafte Zeilen blockieren den Import nicht — sie werden benannt und übersprungen.' },
];

export function WhatsNewModal({
  open, onClose, onDismissForever,
}: {
  open: boolean; onClose: () => void; onDismissForever: () => void;
}) {
  return (
    <Modal open={open} onClose={onClose} title="Was ist neu"
      footer={
        <>
          <button onClick={onDismissForever} className="text-tertiary" style={{ fontSize: 13, marginRight: 'auto', background: 'none', border: 'none', cursor: 'pointer' }}>
            Verstanden, nicht mehr anzeigen
          </button>
          <Button variant="primary" onClick={onClose}>Schließen</Button>
        </>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Badge tone="accent" dot>Version 1.2.0</Badge>
          <span className="text-tertiary" style={{ fontSize: 12.5 }}>Juli 2026</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {ITEMS.map((it, i) => (
            <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <div style={{ width: 30, height: 30, borderRadius: 8, background: 'var(--accent-soft)', color: 'var(--accent)', display: 'grid', placeItems: 'center', flexShrink: 0 }}>
                {it.icon}
              </div>
              <div style={{ fontSize: 13.5, lineHeight: 1.5, paddingTop: 5 }}>{it.text}</div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
